// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__7Jb2Q","buttons":"Footer_buttons__1iVxY"};